import React from "react";
import "./UnderwritingChoicePopup.scss";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
export interface UnderwritingOption {
  value: number | boolean | string;
  labelAr: string;
}

interface UnderwritingChoicePopupProps {
  visible: boolean;
  title: string;
  options: UnderwritingOption[];
  note?: string;
  onSelect: (value: number | boolean | string) => void;
}

export const UnderwritingChoicePopup: React.FC<UnderwritingChoicePopupProps> = ({
  visible,
  title,
  options,
  note,
  onSelect,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  return (
    <div className="underwriting-popup-overlay">
      <div className="card-width underwriting-popup-card">
        <h3 className="underwriting-popup-title">{title}</h3>
        {note && (
          <p className="underwriting-popup-note">
            ملاحظة: {note}
          </p>
        )}
        <div className="underwriting-popup-options">
          {options.map((opt, idx) => (
            <button
              key={idx}
              onClick={() => onSelect(opt.value)}
              className="underwriting-popup-option"
            >
              {opt.labelAr}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
